
import { defineComponent, PropType } from 'vue'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { AbstractTerminalViewService } from '@/views/dashboard/manage/port-manage/_components/abstract-terminal-view/abstract-terminal-view.service'
import AbstractTerminalView from '@/views/dashboard/manage/port-manage/_components/abstract-terminal-view/abstarct-terminal-view.vue'
import { PortBlockDrawerService } from '@/views/dashboard/manage/port-manage/_components/port-view/_components/port-block-drawer.service'
import { PortItem } from '@/views/dashboard/manage/port-manage/_components/port-view/port-view.service'
import { http } from '@/common/basis/root-injector'

export default defineComponent({
  components: {
    AbstractTerminalView
  },
  props: {
    currentPort: {
      type: Object as PropType<PortItem>,
      default: {} as PortItem
    }
  },
  emits: ['closePortTerminal'],
  setup (props, context) {
    const portBlockDrawerService = new PortBlockDrawerService(http)
    useReflectiveInjector([{
      provide: AbstractTerminalViewService as Type<AbstractTerminalViewService>,
      useValue: portBlockDrawerService,
    }])

    portBlockDrawerService.selectItem = (props.currentPort) as PortItem

    return {
      closeDrawer () {
        context.emit('closePortTerminal')
      }
    }
  }
})
